import { WalletYearlyReportQueryResponseType } from '../queries/walletYearlyReport/walletYearlyReportMutation.type';

export const yearlyReportBarChartOptions = {
  responsive: true,
  grouped: false,
  pan: {
    enabled: true,
    mode: 'x',
    threshold: 5,
  },
  plugins: {
    legend: { display: false },
    zoom: {
      pan: {
        enabled: true,
        mode: 'x',
      },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: 'x',
      },
    },
  },
  scales: {
    x: {
      min: 0,
      max: 5,
      stacked: false,
      grid: { display: false },
      border: { display: true },
      ticks: {
        maxRotation: 0,
        minRotation: 0,
        font: {
          family: 'iran-yekan',
          size: 12,
          weight: '500',
          lineHeight: 1.5,
        },
        // This function will make the x-titles stands straight & without 45deg angle
        callback: function (this: any, value: string | number): string {
          const label = this.getLabelForValue(value);
          return label.split(' ');
        },
      },
    },
    y: {
      display: false,
      stacked: false,
      beginAtZero: true,
      grid: { display: false },
    },
  },
};

const dataConfig = {
  borderRadius: {
    topLeft: 8,
    topRight: 8,
    bottomLeft: 0,
    bottomRight: 0,
  },
  borderSkipped: false,
  barThickness: 40,
  categoryPercentage: 1,
  barPercentage: 1,
};

export function generateWalletYearlyReportChartData(
  monthListData: WalletYearlyReportQueryResponseType['months'] | undefined,
) {
  const unpaidData: number[] = [];
  const paidData: number[] = [];
  const normalizedData = {
    labels: [] as string[],
    datasets: [
      {
        data: unpaidData,
        label: 'تسویه نشده',
        backgroundColor: '#D1D1D1',
        order: 2,
        ...dataConfig,
      },
      {
        data: paidData,
        label: 'تسویه شده',
        backgroundColor: '#13BF83',
        order: 1,
        ...dataConfig,
      },
    ],
  };

  for (let month in monthListData) {
    normalizedData.labels.push(monthListData[month].fa_name);
    unpaidData.push(monthListData[month].unpaid);
    paidData.push(monthListData[month].paid);
  }

  // for ascending data sort
  normalizedData.labels.reverse();
  normalizedData.datasets[0].data.reverse();
  normalizedData.datasets[1].data.reverse();

  return normalizedData;
}
